var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('informacion-general-modal',{attrs:{"data":_vm.data,"id":_vm.id,"dataVer":_vm.dataVer,"load":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }